import React from 'react';
import { FeedbackType } from '../../components/App/Content/UserDeveloper/Submission/submission-graphql';
import { formatGraphDateAndTime } from '../formatting';
import { Box } from '@mui/system';
import { COLORS } from '../Styleguide/Common/colors';
import moment from 'moment';

export interface FeedbackProps {
  feedback: FeedbackType;
}

const Feedback: React.FC<FeedbackProps> = ({ feedback }) => {
  return (
    <Box sx={{ maxHeight: 500, overflowY: 'auto', border: `1px solid ${COLORS.black[40]}`, borderRadius: 1 }}>
      {feedback.length === 0 && <p>There is no feedback yet on this submission.</p>}
      {feedback
        .slice(0)
        .sort((a, b) => moment.utc(b.postedOn).diff(moment.utc(a.postedOn)))
        .map((entry) => (
          <Box sx={{ borderBottom: `1px solid ${COLORS.black[40]}`, px: 1, pt: 1 }} key={`${entry.postedOn}`}>
            <Box sx={{ borderRadius: 1, backgroundColor: COLORS.black[50], px: 1, display: 'inline-block' }}>
              <strong>{entry.authorName}</strong> on {formatGraphDateAndTime(entry.postedOn)}
            </Box>
            <div dangerouslySetInnerHTML={{ __html: entry.comment }} />
          </Box>
        ))}
    </Box>
  );
};

export default Feedback;
